module.exports = __webpack_public_path__ + "img/icon_close.4facd97c.png";